import Link from "next/link";
import PlusIcon from "../../icons/plus.icon";
import useCanDoShop from "../../hooks/useCanDoShop.hook";

export default function AddLink({ id, href, cap }: { id: string; href: string; cap?: ShopCap }) {
  const canDo = useCanDoShop(cap);

  if (canDo) {
    return (
      <Link
        id={id}
        href={href}
        className="text-white hover:bg-blue-700 dark:hover:bg-blue-500 bg-blue-500 dark:bg-blue-600 rounded-3xl px-1 py-1"
      >
        <PlusIcon className="w-5 h-5" />
      </Link>
    );
  }

  return (
    <div id={id} className="text-white bg-gray-400 dark:bg-gray-600 rounded-3xl px-1 py-1 ">
      <PlusIcon className="w-5 h-5"></PlusIcon>
    </div>
  );
}
